// extracted by mini-css-extract-plugin
export default {"heading":"Bt-z","corrected":"Ct-z","redirectVerbiageContainer":"Dt-z","redirectVerbiageText":"Et-z"};